import { useNode } from '@craftjs/core';
import {
  TitlePanel,
  AnswersPanel,
  TextFieldPanel,
  LayoutPanel,
  ValidationPanel,
  LogicPanel,
} from 'src/features/generalForms/builder/layout/panels';
import { FormTagInputComponent, FormTagInputProps } from 'src/features/generalForms/builder/types/TagInput';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';
import { AppTagInputField } from 'src/features/generalForms/uikit/fields/tagInput/tagInput';

export const FormTagInput: FormTagInputComponent = (props) => {
  const {
    actions: { setProp },
    connectors: { connect, drag },
    styles,
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const validationResult = useDataKeyValidation();

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={styles}>
      <AppTagInputField
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        disabled={props.disabled}
        values={props.defaultValue || []}
        placeholder={props.placeholder}
        onDeleteTag={(index: number) => {
          if (index < 0) return;

          setProp((p: FormTagInputProps) => {
            const newArr = p.defaultValue?.filter((_: string, i: number) => i !== index);
            p.defaultValue = newArr.length ? newArr : undefined;
          }, 500);
        }}
        onAddTag={(newTag: string) => {
          if (props.defaultValue?.includes(newTag)) return;
          setProp((p: FormTagInputProps) => (p.defaultValue = [...(props.defaultValue || []), newTag]), 500);
        }}
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

export const FormTagInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <AnswersPanel />
    <TextFieldPanel sections={['Placeholder']} />
    <LayoutPanel sections={['Paddings']} />
    <ValidationPanel type={'text'} sections={['Pattern']} />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormTagInput.craft = {
  displayName: 'Tag Box',
  rules: { canDrag: () => true },
  related: { settings: FormTagInputSettings },
};
